export default __webpack_public_path__ + "static/17-20432504a60d014a3f85ffc6ef54cfa1.jpg";